module.exports = __webpack_public_path__ + "static/7f651b.woff";